import { render, staticRenderFns } from "./RequirementSummary.vue?vue&type=template&id=62e27fd0&scoped=true&lang=html&"
import script from "./RequirementSummary.vue?vue&type=script&lang=js&"
export * from "./RequirementSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e27fd0",
  null
  
)

export default component.exports